import { Box } from "@material-ui/core";
import SubTableHeader from "./SubTableHeader";
import SurveySubGridGroupByPeople from "../SurveySubGridGroupByPeople";
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";

const GridChildDetails = ({ dataItem, sortSelected }) => {
  
  return (
    <Box>
      {sortSelected === "Group by question" ? (
        <SubTableHeader data={dataItem} />
        // generateQuestionsDetails(dataItem?.type)
      ) : (
        <SimpleBar
          forceVisible="y"
          style={{ maxHeight: 500 }}
          data-simplebar-auto-hide="false">
          <SurveySubGridGroupByPeople data={dataItem} />
        </SimpleBar>

      )}
    </Box>
  );
};

export default GridChildDetails;
